import apiService from './apiService';

export const getProfile = async () => {
  try {
    const response = await apiService.get('profile');
    return response?.data?.data || null;
  } catch (error) {
    console.error('Error fetching profile:', error);
    // Return null instead of throwing to prevent crashes
    return null;
  }
};
